import TripPlannerLandingPage from './TripPlannerLandingPage'

function TripPlannerLandingRoute() {
  return <TripPlannerLandingPage />
}

export default TripPlannerLandingRoute
